export default "__VITE_ASSET__BsiwICL9__"